import { Record } from 'immutable'

const InitialState = Record({
  locations: [],
  filtered: [],
  isLoading: false,
  current: null,
})

export default InitialState


// WEBPACK FOOTER //
// ./src/reducers/scene/initialState.js